<template>
  <div class="my-alerts-container">
    <v-list class="alert-list-container" two-line v-if="!noAlerts">
      <AlertListItem
        v-for="alert in orderedAlerts"
        :alert="alert"
        :key="alert.id"
        :isMapped="IsMapped(alert)"
        @change="mapOrRemoveAlert"
      ></AlertListItem>
    </v-list>
    <v-list text-align-center v-if="noAlerts">
      <p class="text-center">
        No Alerts Found. Would you like to
        <a @click="openWizard()">create a legacy alert</a>?
      </p>
    </v-list>
  </div>
</template>

<script>
/**
 * @Overview The container for displaying all the alerts a particular user has access to.
 * @NOTE: Possibly replaced by a common component.
 */
import lodashGet from "lodash/get";
import lodashOrderBy from "lodash/orderBy";
import lodashFind from "lodash/find";
import dayjs from "dayjs";

import { mapGetters } from "vuex";
import { OPEN_ALERT_WIZARD } from "@/store/actions.type";
import { MODULE_PREFIX_ALERTS, MODULE_PREFIX_USER } from "@/store";
import DateFilter from "@/components/common/filters/DateFilter";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "AlertsList",
  components: {
    AlertListItem: () => import("@/components/alerts/management/AlertListItem"),
  },
  props: {},
  filters: {
    DateFilter,
  },
  computed: {
    ...mapGetters({
      alerts: MODULE_PREFIX_ALERTS + "alerts",
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
    noAlerts() {
      return this.alerts.length === 0;
    },
    orderedAlerts() {
      if (this.alerts) {
        const ALERTS = lodashOrderBy(this.alerts, (item) => item.name);
        return ALERTS;
      }
      return null;
    },
  },
  methods: {
    isExpired(date) {
      return dayjs().isAfter(date);
    },
    IsMapped(alert) {
      return (
        alert &&
        alert.id &&
        lodashGet(this.preferences, "alerts.mapped") &&
        lodashFind(this.preferences.alerts.mapped, { id: alert.id }) !==
          undefined
      );
    },
    mapOrRemoveAlert(input) {
      this.$emit(EMITTED_ACTIONS.CHANGE, input);
    },
    async openWizard() {
      await this.$store.dispatch(MODULE_PREFIX_ALERTS + OPEN_ALERT_WIZARD, {});
    },
  },
};
</script>

<style scoped>
.theme--light.v-list {
  background: #f7f7fa !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
.alert-list-container {
  height: 80vh !important;
  overflow-y: auto !important;
}
::-webkit-scrollbar {
  width: 8px;
  height: 3px;
}
::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #c8c8c8;
  border-radius: 3px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(204, 204, 204, 1);
  border-radius: 3px;
}
</style>
